import { Button } from '@mui/material';
import { action, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import Modal from '../misc/Modal';
import { CategoriaMinuta, Processo } from '../modelo';
import { MovimentoGEDTO } from '../modelo/MinutaMovimentos';
import CategoriasStore from '../store/CategoriasStore';
import './css/categorias.css';
import BotaoComplementoMovimento from './escaninho/BotaoComplementoMovimento';
import ChipMovimentoCNJ from './escaninho/ChipMovimentoCNJ';

interface IPropsModalMovimentosCategoria {
    categoria: CategoriaMinuta;
    processo: Processo;
    emLote: boolean;
}


class ModalMovimentosCategoria extends React.Component<IPropsModalMovimentosCategoria> {
    fecharModal = () => {
        CategoriasStore.modalComplementosMovimento = false;
    };

    constructor(props: IPropsModalMovimentosCategoria) {
        super(props);

        makeObservable(this, {
            fecharModal: action,
addMovimento: action,
            excluir: action,
});
    }

    get preenchido() {
        return this.props.categoria.movimentoCNJ.every(mov => mov.isComplementosPreenchidos);
    }

    addMovimento = () => {
        const mov = this.props.categoria.movimentoCNJ.slice()[0];
        const movGE = MovimentoGEDTO.novo(mov, this.props.processo);
        movGE.id = this.props.categoria.movimentoCNJ.length + 1;
        this.props.categoria.movimentoCNJ.push(movGE);
    };

    excluir = (movimento: MovimentoGEDTO) => {
        this.props.categoria.movimentoCNJ = this.props.categoria.movimentoCNJ.filter(mov => mov.id != movimento.id);
    };

    get abrirModalComplementosMovimento() {
        return CategoriasStore.modalComplementosMovimento && CategoriasStore.descricaoCategoriaModalMovimento === this.props.categoria.descricao
    }

    render() {
        return (
            <>
                <BotaoComplementoMovimento usarCategoria preenchido={this.preenchido} descricaoCategoria={this.props.categoria.descricao} />
                <Modal
                    aberto={this.abrirModalComplementosMovimento}
                    fecharModal={this.fecharModal}
                    titulo={'Complementos de movimento da categoria ' + this.props.categoria.descricao}
                    funcaoAcaoSecundaria={this.fecharModal}
                    labelAcaoSecundaria='Fechar'
                    maxWidth='md'
                    fullWidth
                >
                    <div className='divFlexColumn'>
                        <div className='chips-movimento-categoria'>
                            {this.props.categoria.movimentoCNJ.filter(mov => mov.variaveis.length > 0)
                                .map((mov, index) =>
                                    <ChipMovimentoCNJ key={mov.id + "_" + index} movimento={mov} processo={this.props.processo as Processo} callbackExcluir={this.excluir} />
                                )
                            }
                        </div>
                        <Button variant='contained' onClick={this.addMovimento}>
                            Adicionar mais um movimento {this.props.categoria.movimentoCNJ[0].codMovimentoCnj}
                        </Button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default observer(ModalMovimentosCategoria);
